export const LandingPage = {
    BRASIL: "https://www.universomedico.com.br/home/default.aspx",
    MEXICO: "https://bescience.bayer.com/es/app-bescience",
    CONOSUR: "https://www.universomedico.com.ar/es-ar",
    PACA: "https://www.universomedico.com.co"
};


// WEBPACK FOOTER //
// ./src/helpers/enums/LandingPageEnum.js